import Vue from 'vue';

const authHub = new Vue();

export default authHub;
